import styled from "styled-components";

import { media } from "../../../../../styles/media";

export const KpiRowStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 20px;

  /* Let the cards shrink below their content's min-content (sparkline + label +
     trend pill) so the row never forces itself wider than the viewport. This is
     the real cause of the earlier horizontal overflow. */
  > * {
    min-width: 0;
  }

  @media (max-width: 1300px) {
    grid-template-columns: repeat(3, 1fr);
  }

  ${media.maxMobile`
    grid-template-columns: 1fr;
  `}
`;
